var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"session__register_print_table"},[_c('component-table',{attrs:{"labels":_vm.tableLabels,"checkbox":false,"items":_vm.items,"component-table-item":_vm.SessionRegisterPrintTableItem,"empty-state-active":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }